// Product cards: hovering or focusing a colour swatch previews that colour's photo.
(function () {
  function getImage(swatch) {
    var card = swatch.closest('.card-wrapper');
    return card ? card.querySelector('.card__media img') : null;
  }

  function preview(swatch) {
    var src = swatch.getAttribute('data-swatch-image');
    var img = getImage(swatch);
    if (!src || !img) return;
    if (!img.hasAttribute('data-original-src')) {
      img.setAttribute('data-original-src', img.getAttribute('src') || '');
      img.setAttribute('data-original-srcset', img.getAttribute('srcset') || '');
    }
    img.removeAttribute('srcset');
    img.setAttribute('src', src);
    var list = swatch.closest('.card-swatches');
    if (list) list.querySelectorAll('.card-swatch.is-active').forEach(function (el) { el.classList.remove('is-active'); });
    swatch.classList.add('is-active');
    var previewCard = swatch.closest('.card-wrapper');
    if (previewCard) previewCard.classList.add('is-swatch-preview');
  }

  function restore(list) {
    var first = list.querySelector('.card-swatch');
    var img = first ? getImage(first) : null;
    if (!img || !img.hasAttribute('data-original-src')) return;
    img.setAttribute('src', img.getAttribute('data-original-src'));
    var srcset = img.getAttribute('data-original-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.removeAttribute('data-original-src');
    img.removeAttribute('data-original-srcset');
    list.querySelectorAll('.card-swatch.is-active').forEach(function (el) { el.classList.remove('is-active'); });
    var restoreCard = list.closest('.card-wrapper');
    if (restoreCard) restoreCard.classList.remove('is-swatch-preview');
  }

  var touchQuery = window.matchMedia ? window.matchMedia('(hover: none)') : null;
  function isTouchDevice() {
    return touchQuery ? touchQuery.matches : false;
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    var swatch = event.target.closest && event.target.closest('.card-swatch');
    if (swatch) preview(swatch);
  });
  document.addEventListener('focusin', function (event) {
    if (isTouchDevice()) return;
    var swatch = event.target.closest && event.target.closest('.card-swatch');
    if (swatch) preview(swatch);
  });
  document.addEventListener('pointerout', function (event) {
    if (event.pointerType === 'touch') return;
    var list = event.target.closest && event.target.closest('.card-swatches');
    if (list && !list.contains(event.relatedTarget)) restore(list);
  });
  document.addEventListener('focusout', function (event) {
    if (isTouchDevice()) return;
    var list = event.target.closest && event.target.closest('.card-swatches');
    if (list && !list.contains(event.relatedTarget)) restore(list);
  });

  // Touch screens: tapping a swatch shows that colour's photo instead of opening the product page.
  // The card's quick add pop-up then opens with that colour selected.
  document.addEventListener('click', function (event) {
    if (!isTouchDevice()) return;
    var swatch = event.target.closest && event.target.closest('.card-swatch');
    if (!swatch) return;
    event.preventDefault();
    preview(swatch);
    var card = swatch.closest('.card-wrapper');
    var opener = card && card.querySelector('.card-quick-view');
    if (opener) {
      if (!opener.hasAttribute('data-default-url')) {
        opener.setAttribute('data-default-url', opener.getAttribute('data-product-url') || '');
      }
      opener.setAttribute('data-product-url', swatch.getAttribute('href'));
    }
  });
})();

// Product cards: clicking the photo opens the quick add pop-up.
// Clicking the title, price or details goes to the product page.
(function () {
  function openQuickView(card, opener) {
    var modal = document.querySelector(opener.getAttribute('data-modal'));
    if (!modal || typeof modal.show !== 'function') return false;
    card.classList.add('is-quick-loading');
    var observer = new MutationObserver(function () {
      if (!opener.classList.contains('loading')) {
        card.classList.remove('is-quick-loading');
        observer.disconnect();
      }
    });
    observer.observe(opener, { attributes: true, attributeFilter: ['class'] });
    modal.show(opener);
    return true;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target;
    if (!target.closest) return;

    var directOpener = target.closest('.card-quick-view');
    if (directOpener) {
      var directCard = directOpener.closest('.card-wrapper');
      if (directCard && openQuickView(directCard, directOpener)) event.preventDefault();
      return;
    }

    // Clicking the product photo (or its "Quick view" label) opens the pop-up.
    // The favourite heart, add button, swatches and the title/price link keep their own behaviour.
    var photo = target.closest('.card--media > .card__inner');
    if (!photo) return;
    if (target.closest('.favourite-toggle, .quick-add, .card-swatches, quick-add-modal, modal-opener, product-form, button, input, select, label, textarea')) return;
    var card = photo.closest('.card-wrapper');
    if (!card) return;

    // A tap that lands just beside the favourite heart counts as a heart tap, never quick add.
    var heart = photo.querySelector('.favourite-toggle--card');
    if (heart && typeof event.clientX === 'number') {
      var rect = heart.getBoundingClientRect();
      var slop = 20;
      if (
        rect.width &&
        event.clientX >= rect.left - slop &&
        event.clientX <= rect.right + slop &&
        event.clientY >= rect.top - slop &&
        event.clientY <= rect.bottom + slop
      ) {
        event.preventDefault();
        heart.click();
        return;
      }
    }

    var opener = card.querySelector('.card-quick-view');
    event.preventDefault();
    if (opener && openQuickView(card, opener)) return;
    var productLink = card.querySelector('.card__heading a[href]');
    var url = (opener && opener.getAttribute('data-product-url')) || (productLink && productLink.getAttribute('href'));
    if (url) window.location.href = url;
  });
})();
